module.exports = __webpack_public_path__ + "static/media/Team 17 Wake Me Up Team Logo - Igor Ferreira.e3bec96d.png";